import './LoadingIndicator.css';
import React, { Component } from 'react';
import loadingIndicator from './LoadingIndicator.gif';

export default class LoadingIndicator extends Component {
  render() {
    return (
      <div className="k-loading-mask">
        <div className="k-loading-image">
          <img src={loadingIndicator} width="40px" alt="Loading Indicator" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator.js